import { ThemeColors } from '~/themes/colors'

interface AudioPlayerColors {
  Container: {
    Background: ThemeColors
    Border: ThemeColors
  }
  Slider: {
    Track: {
      Background: ThemeColors
    }
    FilledTrack: {
      Background: ThemeColors
      HoverBackground: ThemeColors
    }
    Thumb: {
      Background: ThemeColors
      Border: ThemeColors
    }
  }
  Dropdown: {
    Menu: {
      Border: ThemeColors
      Background: ThemeColors
    }
    MenuItem: {
      Hover: {
        Background: ThemeColors
      }
      Active: {
        Background: ThemeColors
      }
    }
  }
  PlaybackTimestampText: {
    FontColor: ThemeColors
  }
  TranscriptionContainer: {
    Background: ThemeColors
    Border: ThemeColors
  }
  Analytics: {
    Slider: {
      Thumb: {
        TrackLine: ThemeColors
      }
    }
  }
}

export const AudioPlayerColors: AudioPlayerColors = {
  Container: {
    Background: {
      default: 'gray.200',
    },
    Border: {
      default: 'gray.400',
    },
  },
  Slider: {
    Track: {
      Background: {
        default: 'gray.500',
      },
    },
    FilledTrack: {
      Background: {
        default: 'gray.1300',
      },
      HoverBackground: {
        default: 'gray.1300',
      },
    },
    Thumb: {
      Background: {
        default: 'gray.800',
      },
      Border: {
        default: 'gray.1300',
      },
    },
  },
  Dropdown: {
    Menu: {
      Border: {
        default: 'gray.400',
      },
      Background: {
        default: 'white',
      },
    },
    MenuItem: {
      Hover: {
        Background: {
          default: 'gray.300',
        },
      },
      Active: {
        Background: {
          default: 'gray.400',
        },
      },
    },
  },
  PlaybackTimestampText: {
    FontColor: {
      default: 'gray.800',
    },
  },
  TranscriptionContainer: {
    Background: {
      default: 'gray.300',
    },
    Border: {
      default: 'gray.400',
    },
  },
  Analytics: {
    Slider: {
      Thumb: {
        TrackLine: {
          default: 'mask.blue.900.20',
        },
      },
    },
  },
}
